import { AxiosInstance } from 'axios';
import { KycResponse } from '@sdk/shared/types/kyc.types';
import { handleServiceError } from '@sdk/utils/error-handler';

/**
 * Service for KYC management (admin scope).
 * All endpoints are prefixed with `/admin/kycs` and therefore **require**
 * an Axios instance configured with a valid admin JWT (see Auth.getAdminAxios()).
 */
export interface KycSubmissionsParams {
  page?: number;
  limit?: number;
  validEmail?: boolean;
  /** Filter by current KYC validation status */
  validKyc?: 'yes' | 'no' | 'pending';
}

export class KycService {
  constructor(private readonly adminAxios: AxiosInstance) {}

  /**
   * List KYC submissions with optional filters / pagination.
   */
  getSubmissions(params: KycSubmissionsParams = {}) {
    return handleServiceError(async () => {
      const { data } = await this.adminAxios.get<KycResponse[]>('/admin/kycs', { params });
      return data;
    }, []);
  }

  /**
   * Validate (approve/reject) a specific KYC submission.
   * @param id    The submission ID
   * @param valid "yes" to approve, "no" to reject
   */
  validate(id: number, valid: 'yes' | 'no') {
    return handleServiceError(async () => {
      const { data } = await this.adminAxios.post<KycResponse>(`/admin/kycs/${id}`, { valid });
      return data;
    }, null);
  }
}
